<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>年费缴纳</el-breadcrumb-item>
    </el-breadcrumb>

     <!-- 搜索筛选 -->
    <!-- <dv-border-box-9> -->
    <div class="search-top">
      <el-form :inline="true" :model="formInline" class="user-search">

        <div>
        <!-- <el-form-item label="申请日:" style="margin-left: 15px;">
           <el-select size="small" v-model="formInline.sqrqType" style="width:100px" placeholder="请选择">
            <el-option v-for="type in sqrqType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="formInline.sqrqType == 1">
        <el-date-picker v-model="formInline.sqrq_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.sqrqType == 1">
          <el-date-picker v-model="formInline.sqrq_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.sqrqType == 2">
          <el-date-picker v-model="formInline.sqrq_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>

        <el-form-item label="公告日:">
          <el-select size="small" v-model="formInline.gkrType" style="width:100px" placeholder="请选择">
            <el-option v-for="type in gkrType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="formInline.gkrType == 1">
        <el-date-picker v-model="formInline.gkr_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px" clearable> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.gkrType == 1">
          <el-date-picker v-model="formInline.gkr_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px" clearable> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.gkrType == 2">
          <el-date-picker v-model="formInline.gkr_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px" clearable> </el-date-picker>
        </el-form-item> -->

        <el-form-item label="申请人:" style="margin-left: 15px;">
          <el-select v-model="formInline.sqr"
          style="width:150px;height:32px;"
          placeholder="请选择申请人"
          clearable
          filterable
          @blur="selectBlurSqr"
          @clear="selectClearSqr"
          @change="selectChangeSqr">
            <el-option v-for="item in searchSqrData" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发明人:" style="margin-left: 15px;">
          <el-select v-model="formInline.fmr"
          style="width:150px;height:32px;"
          placeholder="请选择发明人"
          clearable
          filterable
          @blur="selectBlurFmr"
          @clear="selectClearFmr"
          @change="selectChangeFmr">
            <el-option v-for="item in searchFmrData" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        
        <el-form-item label="专利类型:">
          <el-select size="small" v-model="formInline.zllx" style="width:100px" placeholder="请选择">
            <el-option v-for="type in zllx" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法律状态:">
          <el-select size="small" v-model="formInline.flzt" style="width:100px" placeholder="请选择">
            <el-option v-for="type in legal" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专利号:">
          <el-input size="small" v-model="formInline.zlid"  style="width:120px" placeholder="输入专利号" clearable></el-input>
        </el-form-item>
        <el-form-item label="专利名称:">
          <el-input size="small" v-model="formInline.zlmc"  style="width:120px" placeholder="输入专利名称" clearable></el-input>
        </el-form-item>

        </div>

        <div>

        <el-form-item style="margin-left: 15px;">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">检索</el-button>
          <el-button size="small" type="primary" @click="exportCheck" title="导出勾选中的数据">导出</el-button>
          <el-button size="small" type="primary" @click="exportAll" title="导出满足条件的数据">全部导出</el-button>
          <el-button size="small" type="danger" @click="deleteCheckPatent" title="删除勾选中的数据">删除</el-button>
        </el-form-item>

        </div>

      </el-form>
    </div>

    <el-table size="small" @selection-change="handleSelectionChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="uid" v-if="idShow">
          </el-table-column>
          <el-table-column align="center" prop="zlmc" label="标题" min-width="120">
          </el-table-column>
          <el-table-column align="center" prop="zlid_code" label="专利号" max-width="90">
          </el-table-column>
          <el-table-column align="center" prop="zllx" label="类型" max-width="90">
          </el-table-column>
          <el-table-column align="center" prop="applicant" label="申请人" min-width="100">
          </el-table-column>
          <el-table-column align="center" prop="apply_date" label="申请日" min-width="80">
          </el-table-column>
          <el-table-column align="center" prop="document_date" label="公开(公告)日" min-width="80">
          </el-table-column>
          <el-table-column align="center" prop="inventor" label="发明人" min-width="100">
          </el-table-column>
          <el-table-column align="center" prop="agency" label="代理机构" min-width="80">
          </el-table-column>
          <el-table-column align="center" prop="current_assignee" label="当前权利人" min-width="100">
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleInfo(scope.$index, scope.row)" title="查看专利详情">详情</el-button>
              <el-button size="mini" type="danger" @click="deletePatent(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
  </div>      
</template>
<script>
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            userData: [],
            formInline: {
                page: 1,
                ps: 10,
                sqr: '',
                fmr: '',
                zllx: '',
                flzt: '',
                dljg: '',
                sqrqType: 1,
                gkrType: 1,
                sqrq_start_time: '',
                sqrq_end_time: '',
                sqrq_date: '',
                gkr_start_time: '',
                gkr_end_time: '',
                gkr_date: '',
                zlid: '',
                zlmc: ''
      },
        }
    },
    // 注册组件
    components: {
        Pagination
    },
    /**
     * 数据发生改变
     */
    watch: {},

    /**
     * 创建完毕
     */
    created() {

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

    }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;

}
.el-form-item {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/patent/annual.vue